/* @flow */

//----------------------------------------------------------------------//
//                         Imported NPM modules                         //
//----------------------------------------------------------------------//

import * as React from 'react';

//----------------------------------------------------------------------//
//                     Imported app modules/assets                      //
//----------------------------------------------------------------------//

import styles from './FinderWrapper.module.scss';

//----------------------------------------------------------------------//
//                       Exported React component                       //
//----------------------------------------------------------------------//

export type TypeProps = {
  // eslint-disable-line flow-prefer-exact-object-types
  children: React.Node,
};

function FinderWrapper(props: TypeProps): React.Element<*> {
  const { children }: TypeProps = props;

  return <div className={styles['finder-wrapper']}>{children}</div>;
}

export default FinderWrapper;
